const autosuggestApiUrl = 'https://proxy.ecosia.org/flights/autosuggest/flights';
const AUTOSUGGEST_RESULTS_LIMIT = 12;
export const MEDIA_PARTNER_ID = 1335988;

const referralApiUrl = 'https://skyscanner.net';
const referralPath = '/g/referrals/v1';
const referralPages = {
  dayView: '/flights/day-view',
  monthView: '/flights/calendar-month-view',
  browseView: '/flights/browse-view',
  cheapFlightsTo: '/flights/cheap-flights-to',
};

export const CABIN_CLASS_ECONOMY = 'economy';
export const CABIN_CLASS_PREMIUMECONOMY = 'premiumeconomy';
export const CABIN_CLASS_BUSINESS = 'business';
export const CABIN_CLASS_FIRST = 'first';

const getDefaultMarket = (locale) => {
  const countryCode = locale.substring(3, 5);

  // the following codes are invalid for skyscanner
  if (countryCode === 'ww' || countryCode === 'gb') {
    return 'UK';
  }
  return countryCode.toUpperCase();
};

// those are default values for the user's language
const getLocale = (bingMarket) => {
  const languageCountry = bingMarket.split('-')[0];

  switch (languageCountry) {
    case 'de':
      return 'de-DE';
    case 'es':
      return 'es-ES';
    case 'nl':
      return 'nl-NL';
    case 'fr':
      return 'fr-FR';
    case 'it':
      return 'it-IT';
    default:
      return 'en-GB';
  }
};

/**
 * Requests location suggestions from a search term.
 * Result is a list of places like:
 * {
 *  "entityId": "27539733",
 *  "iataCode": "PAR",
 *  "parentId": "27539733",
 *  "name": "Paris",
 *  "countryId": "FR",
 *  "countryName": "France",
 *  "cityName": "Paris",
 *  "location": "48.85662237511698,2.3428759930239886",
 *  "hierarchy": "Paris|Île-de-France|France",
 *  "type": "PLACE_TYPE_CITY",
 *  "highlighting": [...]
 * }
 * See full example in README.md
 *
 * @param searchTerm {string}
 * @param locale {string}
 * @param bingMarket {string}
 * @param maxResults {number} Optional, defaults to AUTOSUGGEST_RESULTS_LIMIT
 *
 * @returns Promise
 */
export const requestSuggestions = async (searchTerm, locale, bingMarket, maxResults) => {
  // for skyscanner, a market has two digits, unlike bing. eg. 'UK' or 'DE'
  const formattedMarket = getDefaultMarket(bingMarket);
  const formattedLocale = getLocale(locale);

  const response = await fetch(autosuggestApiUrl, {
    method: 'POST',
    body: JSON.stringify({
      query: {
        market: formattedMarket,
        locale: formattedLocale,
        searchTerm,
        includedEntityTypes: ['PLACE_TYPE_CITY', 'PLACE_TYPE_COUNTRY', 'PLACE_TYPE_AIRPORT'],
      },
      limit: maxResults || AUTOSUGGEST_RESULTS_LIMIT,
      isDestination: true,
    }),
  });
  return response.json();
};

export const getReferralsUrl = (type) => `${referralApiUrl}${referralPath}${referralPages[type]}`;
